import { shallowRef } from 'vue'

const isOpen = shallowRef(false)

export function useOverlay() {
  const close = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    close,
  }
}
